import { Store, useStore } from '@tanstack/react-store'

const LOCAL_STORAGE_KEY = 'cortado_sidebar'

interface SidebarState {
  collapsedSections: Record<string, boolean>
}

const defaultState: SidebarState = {
  collapsedSections: {},
}

function loadFromStorage(): SidebarState {
  try {
    const stored = localStorage.getItem(LOCAL_STORAGE_KEY)
    if (stored) {
      return { ...defaultState, ...JSON.parse(stored) }
    }
  } catch (e) {
    console.warn('Failed to load sidebar state:', e)
  }
  return defaultState
}

function saveToStorage(state: SidebarState) {
  try {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(state))
  } catch (e) {
    console.warn('Failed to save sidebar state:', e)
  }
}

export const sidebarStore = new Store<SidebarState>(loadFromStorage())

export const sidebarActions = {
  setSectionCollapsed: (sectionKey: string, collapsed: boolean) => {
    sidebarStore.setState((state) => {
      const newState = {
        ...state,
        collapsedSections: {
          ...state.collapsedSections,
          [sectionKey]: collapsed,
        },
      }
      saveToStorage(newState)
      return newState
    })
  },

  toggleSection: (sectionKey: string) => {
    sidebarStore.setState((state) => {
      const currentCollapsed = state.collapsedSections[sectionKey] ?? false
      const newState = {
        ...state,
        collapsedSections: {
          ...state.collapsedSections,
          [sectionKey]: !currentCollapsed,
        },
      }
      saveToStorage(newState)
      return newState
    })
  },
}

export function useSectionCollapsed(sectionKey: string) {
  return useStore(sidebarStore, (s) => s.collapsedSections[sectionKey] ?? false)
}
